<div class="dgh-print-paper-container" #printTemplate>
  @for (imageChunks of (images$ | async); track imageChunks) {
    <div class="dgh-print-paper">
      @for (image of imageChunks; track image) {
        <archive-mgmt-print-label [image]="image" (labelLoaded)="imageLoaded($event)"></archive-mgmt-print-label>
      }
    </div>
  }
</div>
